import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";

export function useAuthRedirect() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth0();

  useEffect(() => {
    // Avoid bouncing during Auth0 initialization / callback handling.
    if (isLoading) return;
    if (!isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated, isLoading, navigate]);
}